// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterYubikey-Form_cls1__ghWok","cls2":"InviteRegisterYubikey-Form_cls2__GoY3b InviteRegisterYubikey-Form_cls1__ghWok"};